exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".privace-polyce-page {\n  width: 520px;\n  margin: auto;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-line-pack: center;\n      align-content: center;\n  justify-items: center;\n  -ms-flex-align: center;\n      align-items: center;\n  height: 100%;\n  padding-top: 30px;\n  padding-bottom: 30px;\n}\n.privace-polyce-page .body-text {\n  z-index: 1;\n  background: #FFFFFF;\n  margin: 0 auto;\n  padding: 20px 30px 20px 30px;\n  height: 100%;\n  overflow-y: scroll;\n  /*box-shadow: 0 0 20px 0 rgba(0, 0, 0, 0.2), 0 5px 5px 0 rgba(0, 0, 0, 0.24);*/\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/statics/css/privace-policy.css
// module id = ./node_modules/css-loader/index.js?{"importLoaders":1}!./node_modules/postcss-loader/lib/index.js?{"ident":"postcss","plugins":[null,null]}!./src/statics/css/privace-policy.css
// module chunks = 0